<app-nav></app-nav>

<router-outlet></router-outlet>

<app-button-chat [station]="station" *ngIf="phoneNumber"></app-button-chat>

<div class="box-bottom-left">
    <app-button-up></app-button-up>
    <app-player [station]="station"></app-player>
</div>

<app-footer [station]="station"></app-footer>